class Benefit {
  id: number;
  name: string;
  displayName: string;
  type: string | number;
  value: number | string | boolean | null;
  upTo: number | null;
  taxConfig: any | null;
  constructor({id, name, displayName, type, value, upTo, taxConfig }) {
    this.id = id;
    this.name = name;
    this.displayName = displayName;
    this.type = type;
    this.value = value;
    if (upTo) this.upTo = upTo;
    if (taxConfig) this.taxConfig = taxConfig;
  }
}

export enum BenefitEnum {
  CHRISTMASBONUS = 1,
  VACATIONBONUS = 2,
  FOODVOUCHER = 3,
  HOMEOFFICEALLOWANCE = 4,
  HOMEOFFICESETUP = 5,
  LIFEINSURANCE = 6,
  MAJORMEIDCALINSURANCE = 7,
  MINORMEIDCALINSURANCE = 8,
  SAVINGFUND = 9,
  PERFORMANCEBONUS = 10,
  TRAININGBUDGET = 11,
}

export let defaultBenefits = [
  new Benefit({
    id: BenefitEnum.CHRISTMASBONUS,
    name: "christmasBonus",
    displayName: "Aguinaldo",
    type: 1,
    value: 0,
    upTo: null,
    taxConfig: { umaDaily: 30 },
  }),
  new Benefit({
    id: BenefitEnum.VACATIONBONUS,
    name: "vacationBonus",
    displayName: "Prima vacacional",
    type: 2,
    value: 0,
    upTo: null,
    taxConfig: { umaDaily: 15 },
  }),
  new Benefit({
    id: BenefitEnum.FOODVOUCHER,
    name: "foodVoucher",
    displayName: "Vales de despensa",
    type: 3,
    value: 0,
    upTo: 3000,
    taxConfig: null,
  }),
  new Benefit({
    id: BenefitEnum.HOMEOFFICEALLOWANCE,
    name: "homeOfficeAllowance",
    displayName: "Apoyo gastos home office",
    type: 3,
    value: 0,
    upTo: 1000,
    taxConfig: null,
  }),
  new Benefit({
    id: BenefitEnum.HOMEOFFICESETUP,
    name: "homeOfficeSetup",
    displayName: "Apoyo setup de home office",
    type: 5,
    value: 0,
    upTo: 15000,
    taxConfig: null,
  }),
  //new Benefit({
  //  id: BenefitEnum.LIFEINSURANCE,
  //  name: "lifeInsurance",
  //  displayName: "Seguro de vida",
  //  type: 1,
  //  value: 0,
  //  upTo: null,
  //  taxConfig: null,
  //}),
  //new Benefit({
  //  id: BenefitEnum.MAJORMEIDCALINSURANCE,
  //  name: "majorMeidcalInsurance",
  //  displayName: "Gastos medicos mayores",
  //  type: 1,
  //  value: 0,
  //  upTo: null,
  //  taxConfig: null,
  //}),
  //new Benefit({
  //  id: BenefitEnum.MINORMEIDCALINSURANCE,
  //  name: "minorMeidcalInsurance",
  //  displayName: "Gastos medicos menores",
  //  type: 1,
  //  value: 0,
  //  upTo: null,
  //  taxConfig: null,
  //}),
  new Benefit({
    id: BenefitEnum.SAVINGFUND,
    name: "savingFund",
    displayName: "Fondo de ahorro",
    type: 3,
    value: 0,
    upTo: 3900,
    taxConfig: null,
  }),
  new Benefit({
    id: BenefitEnum.PERFORMANCEBONUS,
    name: "performanceBonus",
    displayName: "Bono por performance",
    type: 4,
    value: 0,
    upTo: null,
    taxConfig: null,
  }),
  new Benefit({
    id: BenefitEnum.TRAININGBUDGET,
    name: "trainingBudget",
    displayName: "Presupuesto para estudios",
    type: 4,
    value: 0,
    upTo: 10000,
    taxConfig: null,
  }),
];

/**
 * 1 = días
 * 2 = porcentaje
 * 3 = $ mensual
 * 4 = $ anual
 * 5 = $ unica vez
 */
